import React from 'react';
import Icon from '../../../components/AppIcon';

const DashboardStats = ({ stats }) => {
  const statItems = [
    {
      id: 'trips',
      label: 'Total Trips',
      value: stats?.totalTrips,
      icon: 'MapPin',
      color: 'text-primary',
      bgColor: 'bg-primary/10'
    },
    {
      id: 'countries',
      label: 'Countries Visited',
      value: stats?.countriesVisited,
      icon: 'Globe',
      color: 'text-accent',
      bgColor: 'bg-accent/10'
    },
    {
      id: 'points',
      label: 'Loyalty Points',
      value: stats?.loyaltyPoints?.toLocaleString(),
      icon: 'Star',
      color: 'text-secondary',
      bgColor: 'bg-secondary/10'
    },
    {
      id: 'savings',
      label: 'Total Savings',
      value: `$${stats?.totalSavings?.toLocaleString()}`,
      icon: 'DollarSign',
      color: 'text-success',
      bgColor: 'bg-success/10'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {statItems?.map((item) => (
        <div key={item?.id} className="bg-card rounded-xl p-6 border border-border hover:shadow-lg transition-shadow">
          <div className="flex items-center justify-between mb-3">
            <div className={`p-2 rounded-lg ${item?.bgColor}`}>
              <Icon name={item?.icon} size={20} className={item?.color} />
            </div>
          </div>
          <div className="space-y-1">
            <p className="text-2xl font-bold text-foreground">{item?.value}</p>
            <p className="text-sm text-muted-foreground">{item?.label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DashboardStats;